/** Grymwyrd em português brasileiro para o layout compartilhado (TopNav + Footer). */
export const layoutPtBR = {
  'layout.nav.veil': 'O Véu',
  'layout.nav.encyclopedia': 'Enciclopédia',
  'layout.nav.world': 'O Mundo',
  'layout.nav.play': 'Jogar',
  'layout.nav.books': 'Livros & Regras',
  'layout.nav.community': 'Comunidade',
  'layout.nav.homeAria': 'Página inicial de {world}',
  'layout.nav.search': 'Buscar na enciclopédia',
  'layout.nav.unmute': 'Ativar som ambiente',
  'layout.nav.mute': 'Desativar som ambiente',
  'layout.nav.coinBalance': 'Saldo de moedas',
  'layout.nav.signedInAs': 'Conectado como {name}',
  'layout.nav.enter': 'Entrar em {world}',
  'layout.nav.toggleMenu': 'Alternar menu',
  'layout.nav.dashboard': 'Meu {world} ({name})',
  'layout.nav.signOut': 'Sair',

  'layout.footer.hideLinks': 'Ocultar links do site',
  'layout.footer.showLinks': 'Links & questões legais do site',
  'layout.footer.tagline': 'O mundo vivo de fantasia e horror onde sua lenda se torna canon.',
  'layout.footer.explore': 'Explorar',
  'layout.footer.legal': 'Questões legais',
  'layout.footer.accessibility': 'Acessibilidade',
  'layout.footer.encyclopedia': 'Enciclopédia',
  'layout.footer.world': 'O Mundo',
  'layout.footer.playVtt': 'Jogar (VTT)',
  'layout.footer.books': 'Livros & Regras',
  'layout.footer.terms': 'Termos de Serviço',
  'layout.footer.privacy': 'Política de Privacidade',
  'layout.footer.canonRelease': 'Divulgação de Submissão Canon',
  'layout.footer.aiPolicy': 'Política de IA',
  'layout.footer.cookies': 'Preferências de Cookies',
  'layout.footer.copyright': '© 2026 GameCodex',
}
